import React from 'react';
import { ReactComponent as LogoSvg } from '../../../../assets/marimosca-main-logo.svg';
import styles from './onboardingHero.module.css';

const HeroLogo: React.FC = () => (
  <div className={styles.logo}>
    <LogoSvg className={styles.logoSvg} aria-label="Mariana Mósca" />
  </div>
);

export default HeroLogo;
